/**
 * Feature flags for Member Application Links.
 *
 * Nothing in this feature is visible to members while MEMBER_APPLICATIONS_ENABLED
 * is false. Papers stay marked DRAFT while APPLICATION_FORMATS_APPROVED is false.
 */

export const MEMBER_APPLICATIONS_ENABLED = true;

export const APPLICATION_FORMATS_APPROVED = true;
